import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQ_ITEMS = [
  {
    q: "How quickly will I see results?",
    a: "Most men report increased energy and drive within 2–4 weeks of consistent daily use. Compounded benefits — strength, recovery, body composition — typically show by week 6–8. Supplements are not magic; they reward consistency.",
  },
  {
    q: "Can I take Longevi-D and Tenaci-T together?",
    a: "Yes. The two formulas are designed to stack. Tenaci-T supports baseline testosterone and drive over the long term; Longevi-D provides on-demand circulation and performance support. Together they form the complete protocol.",
  },
  {
    q: "Are Primenax products natural?",
    a: "Yes. Every formula is built on naturally-sourced ingredients: clinically-studied botanicals, adaptogens, vitamins, and minerals. No synthetic hormones. No banned compounds.",
  },
  {
    q: "Is Primenax safe to take with my workout supplements?",
    a: "Primenax pairs cleanly with most pre-workouts, creatine, and protein. We recommend discussing any new supplement with your physician if you take prescription medication.",
  },
  {
    q: "What if it doesn't work for me?",
    a: "We back every order with a 30-day money-back guarantee. If you don't feel the difference, contact our team for a refund — no friction, no fine print.",
  },
  {
    q: "How fast is shipping?",
    a: "US orders typically arrive within 3–5 business days. Free shipping on orders over $75. Discreet packaging — your business is your business.",
  },
  {
    q: "Where are Primenax products made?",
    a: "Manufactured in the USA in cGMP-certified facilities. Every batch is third-party tested for potency and purity.",
  },
  {
    q: "Do you ship internationally?",
    a: "We currently ship across the United States. International availability is launching in phases — join the newsletter to be notified.",
  },
];

const FAQ = () => {
  return (
    <div className="bg-[#050505] text-white">
      <section className="max-w-[1100px] mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-20">
        <div className="font-display text-xs tracking-[0.3em] text-[#D10000] mb-4">
          ANSWERS
        </div>
        <h1
          className="font-display uppercase leading-[0.9] tracking-tight"
          style={{ fontSize: "clamp(3rem, 8vw, 7rem)" }}
        >
          FAQ
        </h1>
        <p className="mt-6 max-w-xl text-white/60 leading-relaxed">
          Everything you need to know before you commit to the protocol.
        </p>

        <div className="mt-16">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQ_ITEMS.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display text-xl md:text-2xl tracking-wider uppercase text-white hover:no-underline py-6"
                >
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/70 leading-relaxed text-base pb-6">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
